import TwitterIcoSvg from '../assets/twitter (3).svg';

export function TwitterIcon({ className = '' }: { className?: string }) {
    return <img className={className} src={TwitterIcoSvg} alt='twitter logo' />;
}
